var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyListNactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.0968H11C11.55 15.0968 12 14.6468 12 14.0968V10.0968C12 9.5468 11.55 9.0968 11 9.0968H8C7.45 9.0968 7 9.5468 7 10.0968V14.0968C7 14.6468 7.45 15.0968 8 15.0968ZM8 22.0968H11C11.55 22.0968 12 21.6468 12 21.0968V17.0968C12 16.5468 11.55 16.0968 11 16.0968H8C7.45 16.0968 7 16.5468 7 17.0968V21.0968C7 21.6468 7.45 22.0968 8 22.0968ZM14 22.0968H17C17.55 22.0968 18 21.6468 18 21.0968V17.0968C18 16.5468 17.55 16.0968 17 16.0968H14C13.45 16.0968 13 16.5468 13 17.0968V21.0968C13 21.6468 13.45 22.0968 14 22.0968ZM20 22.0968H23C23.55 22.0968 24 21.6468 24 21.0968V17.0968C24 16.5468 23.55 16.0968 23 16.0968H20C19.45 16.0968 19 16.5468 19 17.0968V21.0968C19 21.6468 19.45 22.0968 20 22.0968ZM14 15.0968H17C17.55 15.0968 18 14.6468 18 14.0968V10.0968C18 9.5468 17.55 9.0968 17 9.0968H14C13.45 9.0968 13 9.5468 13 10.0968V14.0968C13 14.6468 13.45 15.0968 14 15.0968ZM19 10.0968V14.0968C19 14.6468 19.45 15.0968 20 15.0968H23C23.55 15.0968 24 14.6468 24 14.0968V10.0968C24 9.5468 23.55 9.0968 23 9.0968H20C19.45 9.0968 19 9.5468 19 10.0968Z",
    fill: "#ADB8CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyListNactive);
export default __webpack_public_path__ + "static/media/company_list_nactive.da367f7b6b519509bb3311ff7e3512b5.svg";
export { ForwardRef as ReactComponent };